import { type FC } from "react";
import { Card, Shortcut, ShortcutsIcons } from "widgets";

import style from "./Shortcuts.module.css";

export const ShortcutsCard: FC = () => {
  return (
    <Card fillHeight noBorder title="Mouse & Keyboard Actions" contentStyle={{ background: "white" }}>
      <div className={style.tab_container}>
        <div>
          <div className={style.shortcut}>
            Move Tracks Canvas
            <img src={ShortcutsIcons.MouseMove} width={30} height={30} />
          </div>
          <div className={style.shortcut}>
            Asynchronous Scrolling (Long Press)
            <img src={ShortcutsIcons.MousePan} width={30} height={30} />
          </div>
          <div className={style.shortcut}>
            Asynchronous Scrolling
            <Shortcut label={"Space"} className={style.key_symbol} />
          </div>
        </div>
        <div>
          <div className={style.shortcut}>
            Range Zoom
            <div className={style.symbols}>
              <Shortcut label={"⌘ Ctrl / Cmd"} className={style.key_symbol} />
              <img src={ShortcutsIcons.MousePan} width={30} height={30} />
            </div>
          </div>
          <div className={style.shortcut}>
            Zoom In/Out
            <div className={style.symbols}>
              <Shortcut label={"⌘ Ctrl / Cmd"} className={style.key_symbol} />
              <img src={ShortcutsIcons.MouseWheel} width={30} height={30} />
            </div>
          </div>
          <div className={style.shortcut}>
            Entity Info Popover
            <img src={ShortcutsIcons.RightClick} width={30} height={30} />
          </div>
        </div>
        <div>
          <div className={style.shortcut}>
            Select Entity
            <img src={ShortcutsIcons.SimpleClick} width={30} height={30} />
          </div>
          <div className={style.shortcut}>
            Multi Select
            <div className={style.symbols}>
              <Shortcut label={"⌘ Ctrl / Cmd"} className={style.key_symbol} />
              <img src={ShortcutsIcons.SimpleClick} width={30} height={30} />
            </div>
          </div>
          <div className={style.shortcut}>
            Range Selection
            <div className={style.symbols}>
              <Shortcut label={"⇧ Shift"} className={style.key_symbol} />
              <img src={ShortcutsIcons.MousePan} width={30} height={30} />
            </div>
          </div>
          <div className={style.shortcut}>
            Clear Selection
            <div className={style.symbols}>
              <Shortcut label={"C"} className={style.key_symbol} />
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};
